module.exports = __webpack_public_path__ + "media/images/facebook-share-btn-4d2c0081ff3a28973ea145594e4b850c.png";